import { defaultFetch } from './baseApi';

export type NovuInfoType = {
	application: string;
	restApi: string;
	socketUrl: string;
	applicationId: string;
	subscriberId: string;
	subscriberHash: string;
};

export const getNovuInfo = async () => {
	return await defaultFetch<NovuInfoType>('/v0/novu');
};
